module.exports = __webpack_public_path__ + "static/media/модернізація-зерносушарок.337d1197.jpg";